export default __webpack_public_path__ + "static/media/facebook.1a58a8b0.svg";